import script from "./SignIn.vue?vue&type=script&setup=true&lang=js"
export * from "./SignIn.vue?vue&type=script&setup=true&lang=js"

import "./SignIn.vue?vue&type=style&index=0&id=ba07a486&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ba07a486"]])

export default __exports__